// extracted by mini-css-extract-plugin
export default {"title":"Result_title__CQkOg","img":"Result_img__-wKTu"};